var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`${_vm.containerClass} text-${_vm.variant}`,style:(`${_vm.containerStyle}`)},[_c('i',{staticClass:"fa fa-spin",class:`${_vm.fontVariant}`}),_vm._v(" "),(_vm.addText)?_c('span',[_vm._v(" "+_vm._s(_vm.loadingText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }